import { useEffect, useState } from "react";
import api from "../components/api";
import { useQuery, useMutation } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import toast from 'react-hot-toast'

type iAvalistaBusca = {

    avalista_id: number,
    exibicao: string,

}

type iDadosAvalista = {

    cliente_id: number,
    tomador_id: number,
    avalista_id: number,
    usuario_id: number,

}

type iAvalistasTomadores = {

    avalista_id: number,
    cpf: string,
    cnpj: string,
    outroDocumento: string,
    outroDocumentoDescricao: string,
    nome: string,
    nomeFantasia: string,
    razaoSocial: string,
    exibicao: string,
    avalistaTomador_id: number,


}


export default function TomadorAvalistas(props: any) {

    const { cliente_id, usuario_id, tomador_id } = props

    //const [colorAvalista, setColorAvalista] = useState<string>('#FFF')

    const [resultadoAvalista, setResultadoAvalista] = useState<React.ReactNode>()
    const [avalista_id, setAvalista_id] = useState<number | undefined>()
    const [avalista, setAvalista] = useState<string | undefined>('')

    //const [avalistasTabela, setAvalistasTabela] = useState<React.ReactNode>()



    const { data, isLoading } = useQuery({

        queryKey: ['buscaAvalista', cliente_id, avalista],
        queryFn: async () => {

            try {

                const dataPost = {

                    cliente_id,
                    busca: avalista,

                }

                //console.log(dataPost)

                const result = await api.post<iAvalistaBusca[]>('avalistaBusca', dataPost)
                //console.log(result.data)
                return result.data ?? []

            } catch (err: any) {

                console.log(err.response)
                throw err

            }
            

        },
        enabled: !!avalista && avalista.length >= 3

    })


    const { mutate: adicionaAvalista } = useMutation({

        mutationKey: ['adicionaAvalista', cliente_id],
        mutationFn: async (data: iDadosAvalista) => {


            var dataPost = {

                cliente_id: data.cliente_id,
                avalista_id: data.avalista_id,
                ad_usr: data.usuario_id,
                tomador_id: data.tomador_id,

            }

            //console.log(dataPost)

            const result = await api.post('avalistaTomador', dataPost)
            //console.log(result.data)
            return result.data ?? {}

        },
        onSuccess: (data: any) => {

            setResultadoAvalista('')

            if (data.status == 'ok') {

                refetch()
                setAvalista('')
                toast.success('Registro salvo com sucesso!')

            }

        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }


    })
    

    useEffect(() => {

        if (data) {


            setResultadoAvalista(data.map((rs: iAvalistaBusca) =>

                <Link to='#' onClick={() => adicionaAvalista({

                    avalista_id: rs.avalista_id,
                    tomador_id,                    
                    cliente_id,
                    usuario_id,

                })}><span style={{ color: 'red' }}>[</span>{rs.exibicao}<span style={{ color: 'red' }}>]</span>&nbsp;</Link>


            ))


        }

    }, [data])


    const { data: avalistasTabela, refetch } = useQuery({

        queryKey: ['avalistasTomadores', cliente_id, tomador_id],
        queryFn: async () => {

            try {

                var dataPost = {

                    cliente_id,
                    tomador_id,

                }

                const result = await api.post<iAvalistasTomadores[]>('avalistaTomadorLista', dataPost)
                //console.log(result.data)
                return result.data ?? []

            } catch (err: any) {

                console.log(err.response)
                throw err

            }

        },

        enabled: !!tomador_id,

    })


    useEffect(() => {


        props.setTotalAvalistas(avalistasTabela?.length ?? 0)


    }, [avalistasTabela])



    const { mutate: apagaAvalista } = useMutation({

        mutationKey: ['apagaAvalista'],
        mutationFn: async (avalistaTomador_id: number) => {

            const result = await api.delete(`avalistaTomador/${cliente_id}/${avalistaTomador_id}`)
            //console.log(result.data)
            return result.data ?? {}

        },
        onSuccess: (data: any) => {

            if (data.status == 'ok') {

                toast.success('Registro apagado com sucesso!')
                refetch()

            }

        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }

    })


    return (

        <div>

            <form className="row g-3">

            <div className="col-md-12">

                <input type="text"
                    className="form-control"
                    //style={{ backgroundColor: colorAvalista }}
                    value={avalista}
                    onChange={event => setAvalista(event.target.value)} onFocus={() => { setAvalista(''); setResultadoAvalista(''); setAvalista_id(undefined) }}
                    placeholder="Busque o avalista para vinculação (mínimo 3 caracteres)"
                />
                {resultadoAvalista}
            </div>
            <div className="col-md-12">
                <fieldset className="form-group">


                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', backgroundColor: '#EFEFEF' }}>



                                </th>

                                <th style={{ fontSize: '11px', backgroundColor: '#EFEFEF', textAlign: 'right' }}>

                                    &nbsp;

                                </th>

                            </tr>

                        </thead>
                        <tbody>

                            {
                                avalistasTabela?.map((rs: iAvalistasTomadores) => 
                                

                                    <tr>
                                        <td>
                                            {rs.exibicao}
                                        </td>
                                        <td style={{ cursor: 'pointer' }} onClick={() => apagaAvalista(rs.avalistaTomador_id)}>
                                            <span style={{ color: 'orange' }} >[Apagar]</span>
                                        </td>
                                    </tr>

                                
                                )
                            }

                        </tbody>

                    </table>



                </fieldset>
            </div>



            </form>

        </div>

    )


}